import styled, { StyledProps } from 'styled-components/macro';

export type CheckBoxStylesProps = StyledProps<{
  checked: boolean;
  disabled: boolean;
  tabIndex: any;
}>;

const switchBgColor = (props: CheckBoxStylesProps) => {
  if (props.disabled) {
    return '#E6E6E6';
  }

  return props.checked ? props.theme.colors.blue : props.theme.colors.white;
};

const switchBorder = (props: CheckBoxStylesProps) => {
  if (props.disabled) {
    return '1px solid #D1D1D1';
  }

  return props.checked ? '1px solid #0076BF' : '1px solid #8795A2';
};

export const CheckBox = styled.div`
  display: flex;
  align-items: center;
`;

export const CheckBoxItem = styled.div`
  width: 16px;
  height: 16px;
  background: ${switchBgColor};
  border: ${switchBorder};
  box-sizing: border-box;
  box-shadow: ${props => props.checked ? '0 0 0' : 'inset 0px 0.6px 3px rgba(0, 0, 0, 0.5)'};
  border-radius: 3px;
  cursor: pointer;
  transition: .2s;
  display: flex;
  justify-content: center;
  align-items: center;
  color: ${props => props.disabled ? '#BCBCBC' : '#fff'};
  pointer-events: ${props => props.disabled ? 'none' : 'auto'};

  &:focus {
    border: 1px solid #009BF0;
    box-shadow: inset 0px 0.6px 3px rgba(0, 0, 0, 0.5);
    outline: none;
  }

  &:hover {
    border: 1px solid #0076BF;
    box-shadow: inset 0px 0.6px 3px rgba(0, 0, 0, 0.5);
    outline: none;
  }
`;

export const Label = styled.div`
  display: flex;
  align-items: center;
  font-size: 12px;
  color: #1D1E25;
  margin-left: 5px;
  cursor: pointer;
`;